import React, { useContext, useState, useEffect, useCallback, useRef } from "react";
import { BrowserRouter, Switch, NavLink, Route, Redirect, useRouteMatch } from "react-router-dom";
import context, { useTranslation } from "../../context";
import Layout from "../../Layout";
import api from "../../api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, time, openLink } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
// import { Icons } from "../../Icon";
import ShareIcon from "../../components/List/ShareIcon";
// import Popover from "./Popover";
import { pageSize } from "../../config/basics.config";
import { Button, message, Modal } from "antd";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType } from "../../types";
import { PageRouteName } from "../../batchOperate";
import "../../common/index.less";
import "../Trashes/index.less";
import UpdataService from "../../reloadUtils";
import { useListData } from "../../components/TableList/Use/useListData";
import ContextMenu from "../../components/List/ContextMenu";
import contextMenus from "../../contextMenus";
import { JoyspaceState } from "@/models/joyspace";
import { connect } from "dva";
import qs from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import styles from "./index.module.less";
import Icon, { Icons } from "../../Icon";
import { FolderTypeNames } from "../../config/permissions.config";
import { deleteTagsRecords } from "../../api/tags";
import Filters from "../../components/List/Filters";
import { Order, Sort, timeFilter, titleFilter } from "../../components/List/Filters/config";

const key = MenusType.TRASHES;

function TagsList(props: { setTotalLenth?: Function; folderInfoMap: any; getTags: Function }) {
  const [tagId, setTagId] = useState<number>();
  const [columns, setColumns] = useState([
    {
      title: "",
      key: "title",
      dataIndex: "title",
      ellipsis: true,
      filters: true,
      render: () => <Filters onChange={changeSort} isArrowDownIcon={true} menu={titleFilter()} />
    },
    {
      title: "",
      key: "time",
      dataIndex: "time",
      width: "20%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left,
      filters: true,
      render: () => <Filters onChange={changeSort} menu={timeFilter()} />
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "10%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);
  const { setTotalLenth, folderInfoMap, getTags } = props;
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [tagInfo, setTagInfo] = useState<any>();
  const order = useRef<Order>(Order.DESC);
  const sort = useRef<Sort>(Sort.UpDateTime);

  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { user, currentRouterInfo } = useContext(context);
  const location = useLocation();

  const changeSort = useCallback(
    (option: any) => {
      order.current = option.order;
      sort.current = option.sort;
      setList([]);
      getList({ start: 0 }, Number(tagId), true);
    },
    [tagId]
  );

  useEffect(() => {
    setColumns([
      {
        title: "",
        key: "title",
        dataIndex: "title",
        ellipsis: true,
        filters: true,
        render: () => <Filters onChange={changeSort} isArrowDownIcon={true} menu={titleFilter()} />
      },
      {
        title: "",
        key: "time",
        dataIndex: "time",
        width: "20%",
        style: {
          minWidth: "142px"
        },
        justifyContent: JustifyContent.Left,
        filters: true,
        render: () => <Filters onChange={changeSort} menu={timeFilter()} />
      },
      {
        title: "",
        key: "actions",
        dataIndex: "actions",
        actions: true,
        width: "10%",
        style: {
          minWidth: "30px"
        },
        justifyContent: JustifyContent.Center
      }
    ]);
    return () => {
      order.current = Order.DESC;
      sort.current = Sort.UpDateTime;
      setColumns([]);
    };
  }, [changeSort]);

  const getList = (params: any, tagId?: number, isSetLoading?: boolean) => {
    if (typeof tagId === "undefined" || isNaN(tagId)) {
      setList([]);
      return;
    }
    isSetLoading && setLoading(true);
    setLoadingMore(true);
    api.tags
      .listByTag({
        tagId,
        length: 30,
        start: params.start | 0,
        order: order.current,
        sort: sort.current
      })
      .then((res) => {
        if (res) {
          res.pages = (res.pages || []).map((item: any) => {
            item.time = time.format(item.updated_at);
            item.title = item.title || "无标题";
            // item.isDisabled = true;
            return item;
          });
          setList((list) => [...list, ...res.pages]);
          setTotal(res.total);
        }
        isSetLoading && setLoading(false);
        setLoadingMore(false);
        // resolve(res);
      })
      .catch((e) => {
        // reject(e);
        isSetLoading && setLoading(false);
        setLoadingMore(false);
      });
  };

  useEffect(() => {
    setIsLoadMore(list.length < total);
  }, [list, total]);

  useEffect(() => {
    const query = qs.parse(location.search);
    const tagId = typeof query.tagId === "string" ? Number(query.tagId) : query.tagId;
    setTagId(Number(tagId));
    setList([]);
    getList({ start: 0 }, Number(tagId), true);
  }, [location.search]);

  useEffect(() => {
    if (typeof tagId === "undefined") {
      return;
    }
    const tagInfo = folderInfoMap[tagId];
    setTagInfo(tagInfo);
  }, [tagId, folderInfoMap]);

  useEffect(() => {
    setTotalLenth?.(total);
  }, [total, setTotalLenth]);

  const onButtom = () => {
    if (isLoadMore && !loadingMore) {
      getList({ start: list.length }, tagId, false);
    }
  };

  const setData = useCallback((data: any) => {
    events.emit("list.partial.refresh", {
      changeData: data,
      key
    });
  }, []);

  const refresh = useCallback(() => {
    getTags(FolderTypeNames.TAGS);
    setList([]);
    getList({ start: 0 }, tagId, true);
  }, [tagId]);

  return (
    <div className="joyspace-trashes-wrap">
      <Layout>
        <div className="joyspace-header">
          <Layout.Breadcrumbs text={`${tagInfo?.name}(${tagInfo?.count})`} />
          <Icon
            type="iconbtn_editor_refresh"
            className={styles["joyspace-tag-title-icon"]}
            onClick={refresh}
          />
        </div>
        <div className="joyspace-trashes joyspace-list-table joyspace-child-list joyspace-main-ai">
          <TableList
            isLoadMore={isLoadMore}
            columns={columns}
            list={list}
            loading={loading}
            isRoot={false}
            from={PageRouteName.TRASHES}
            handleItem={(item: any, data: any) => {
              openLink(data, globalContext?.appRuntimeEnv.joyspaceHost || "");
            }}
            pagination={true}
            showAI={false}
            renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
              return (
                <ContextMenu
                  render={contextMenus.tags("MY_SPACE", globalContext, currentRouterInfo)}
                  callbackProps={{
                    contextMenuMode,
                    data: item,
                    originId: "",
                    setData,
                    remove: () => {
                      if (typeof tagId !== "undefined") {
                        deleteTagsRecords({
                          bizId: item.id,
                          bizType: 0,
                          tagIds: [tagId?.toString()]
                        }).then((res) => {
                          if (res.code === "200") {
                            const curList = list.filter((i) => i.id !== item.id);
                            setList([...curList]);
                            setTotal((total) => total - 1);
                            getTags(FolderTypeNames.TAGS);
                          } else {
                            message.error(res.status);
                          }
                        });
                      }
                    },
                    reload: () => {
                      console.log("reload");
                    }
                  }}
                />
              );
            }}
            preOptions={(item, data, isExist) => {
              return (
                item.dataIndex === "title" &&
                (data.icon_url ? (
                  <img
                    src={
                      !isExist
                        ? changeEgovUrl(data.icon_url)
                        : getIconUrl(data.type || data.page_type)
                    }
                    data-icon
                  />
                ) : (
                  <ShareIcon isShared={false} />
                ))
              );
            }}
            onButtom={onButtom}
            // handleItem={openPage}
          />
        </div>
      </Layout>
    </div>
  );
}
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  // console.log(joyspace, ' joyspace.folderInfo===>');
  return {
    currentRouterInfo: joyspace.currentRouterInfo,
    folderInfoMap: joyspace.folderInfoMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getTags(data: any) {
      return dispatch({ type: "joyspace/getTags", payload: { ...data } });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsList);
